module.exports = __webpack_public_path__ + "img/loyalty_tumb.25d194de.png";